import React, { useEffect } from 'react';
import CustomBtn from '../../../../generic/CustomBtn';

const SubzoneModal = ({ closeHandler, submitHandler, closeBtnText, submitBtnText, modalText, modalTitle }) => {
  const closeModal = () => {
    document.body.classList.remove('no-scroll');
    closeHandler();
  };

  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  return (
    <div className="project__modal-wrapper">
      <div className="project__modal">
        {modalTitle && <h3 className="project__modal-title">{modalTitle}</h3>}
        <div className="project__modal-text">{modalText}</div>
        <div className="project__modal-btns">
          <CustomBtn
            label={closeBtnText}
            customClass="btn__project-modal"
            type="button"
            handleClick={() => closeModal()}
          />
          <CustomBtn
            label={submitBtnText}
            customClass="btn__project-modal"
            type="button"
            handleClick={submitHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default SubzoneModal;
